import { Helmet } from "react-helmet-async";
import { ReactNode } from "react";

interface PageSeoProps {
  title: string;
  description: string;
  path?: string;
  jsonLd?: object | object[];
  children?: ReactNode;
}

const SITE = "https://commentsbot.com";

export default function PageSeo({ title, description, path = "/", jsonLd, children }: PageSeoProps) {
  const url = `${SITE}${path}`;
  const ldArray = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {ldArray.map((ld, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(ld)}</script>
      ))}
      {children}
    </Helmet>
  );
}
